import OptionsButton from './OptionsButton';
import l from 'services/logger';
import downloadJs from 'downloadjs';
import { getPdf, makeShortLink } from '../../store/actions/shareButtons';
import { getToken } from '../../store/actions/token';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ReactGA from 'react-ga';

const openPopup = popupName => {
  const popup = document.querySelector(`[data-popup-name="${popupName}"]`);
  if (!!popup) {
    popup.classList.add('open');
  }
};

const ShareOptionsButtons = props => {
  const {
    dispatch,
    token,
    getImageFromCanvasOpenDoor,
    getImageFromCanvasCloseDoor,
    getPricesInfo,
  } = props;

  useEffect(() => {
    dispatch(getToken());
    dispatch(makeShortLink(token));
  }, [dispatch, token]);

  const [pdfDownload, setPdfDownload] = useState(false);

  const generatePdf = async () => {
    if (!pdfDownload) {
      setPdfDownload(true);
      const openDoor = await getImageFromCanvasOpenDoor();
      const closeDoor = await getImageFromCanvasCloseDoor();
      const prices = getPricesInfo();

      getPdf(token, openDoor, closeDoor, prices)
        .then(response => {
          downloadJs(response.data, `${props.token}.pdf`, 'application/pdf');
          setPdfDownload(false);
        })
        .catch(() => {
          setPdfDownload(false);
        });
    }
  };

  const openSocialShareNavigation = async () => {
    if (navigator.share !== undefined) {
      const shareData = {
        title: 'BRW konfigurator szaf flex',
        url: props.link,
      };
      try {
        await navigator.share(shareData);
      } catch (e) {
        l.error(e);
      }
    } else {
      openPopup('share-social-popup');
    }
    ReactGA.event(
      {
        category: 'Shares',
        action: 'Share',
        transport: 'beacon',
      },
      ['tracker1', 'tracker2'],
    );
  };

  const labelPdf = pdfDownload ? 'Proszę czekać' : 'Pobierz PDF';

  return (
    <div className="options options--share">
      <OptionsButton
        text="Wyślij mail"
        icon="mail"
        popupName="send-email-popup"
        clickFunction={() => {
          openPopup('share-email-send-popup');
        }}
      />
      <OptionsButton
        text="Kopiuj link"
        icon="link"
        clickFunction={() => {
          openPopup('share-make-link-popup');
        }}
      />
      <OptionsButton text={labelPdf} icon="pdf" clickFunction={generatePdf} />
      <OptionsButton
        text="Udostępnij"
        icon="link-2"
        popupName="social-share-popup"
        clickFunction={openSocialShareNavigation}
      />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    token: state.token.token,
    link: state.socialShare.hash ?? '',
  };
};

export default connect(mapStateToProps, null)(ShareOptionsButtons);
